import { CURRENT_ENV } from 'utils/constants';

import type { EnvType } from 'utils/constants';

/**
// Example 1: Getting Salesforce ID
const contentId = getEnvValue(
  body.newValue.data?.templateInfo?.entryDetails?.salesforce,
  ENV_KEY_MAPS.salesforce
);
// Returns 'devId' value if DEV, 'testId' if UAT, 'qaId' if QA, 'productionId' if PROD

// Example 2: Getting Bridge function ID
const bridgeFunctionId = getEnvValue(
  body.newValue.data?.bridge,
  ENV_KEY_MAPS.bridge
);

// Example 3: Getting URL
const apiUrl = getEnvValue(
  body.newValue.data?.urls,
  ENV_KEY_MAPS.urls
);

// Example 4 custom field names

const customValue = getEnvValue(
  someObject,
  {
    DEV: 'devFieldName',
    UAT: 'uatFieldName',
    QA: 'qaFieldName',
    PROD: 'prodFieldName',
  }
);

**/

type EnvKeyMap = Record<EnvType, string>;

export const getEnvValue = <T extends Record<string, any>>(obj: T | undefined, keyMap: EnvKeyMap): string => {
  const env = (CURRENT_ENV?.toUpperCase() || 'DEV') as EnvType;
  const key = keyMap[env];

  return obj?.[key] ?? '';
};

export const getEnvKey = (keyMap: EnvKeyMap): string => {
  const env = (CURRENT_ENV?.toUpperCase() || 'DEV') as EnvType;

  return keyMap[env];
};

export const ENV_KEY_MAPS = {
  salesforce: {
    DEV: 'devId',
    UAT: 'testId',
    QA: 'qaId',
    PROD: 'productionId',
  },
  bridge: {
    DEV: 'bridgeDevId',
    UAT: 'bridgeStagingId',
    QA: 'bridgeQaId',
    PROD: 'bridgeProductionId',
  },
  urls: {
    DEV: 'dev_url',
    UAT: 'staging_url',
    QA: 'qa_url',
    PROD: 'production_url',
  },
  isStagingGuard: {
    DEV: 'staging',
    UAT: 'staging',
    QA: 'staging',
    PROD: 'prod',
  },
  // Add more as needed:
  // apiKeys: {
  //   DEV: 'devApiKey',
  //   UAT: 'uatApiKey',
  //   QA: 'qaApiKey',
  //   PROD: 'prodApiKey',
  // },
} as const satisfies Record<string, EnvKeyMap>;
